exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".panel-title[data-v-1f0f3962]{font-size:14px;font-weight:600;color:#303133;margin-bottom:10px}", ""]);

// exports
